var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_510_20747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.625 3.375V5.625H3.375V3.375H14.625ZM14.625 2.25H3.375C3.07663 2.25 2.79048 2.36853 2.5795 2.5795C2.36853 2.79048 2.25 3.07663 2.25 3.375V5.625C2.25 5.92337 2.36853 6.20952 2.5795 6.4205C2.79048 6.63147 3.07663 6.75 3.375 6.75H14.625C14.9234 6.75 15.2095 6.63147 15.4205 6.4205C15.6315 6.20952 15.75 5.92337 15.75 5.625V3.375C15.75 3.07663 15.6315 2.79048 15.4205 2.5795C15.2095 2.36853 14.9234 2.25 14.625 2.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 9V14.625H3.375V9H5.625ZM5.625 7.875H3.375C3.07663 7.875 2.79048 7.99353 2.5795 8.20451C2.36853 8.41548 2.25 8.70163 2.25 9V14.625C2.25 14.9234 2.36853 15.2095 2.5795 15.4205C2.79048 15.6315 3.07663 15.75 3.375 15.75H5.625C5.92337 15.75 6.20952 15.6315 6.4205 15.4205C6.63147 15.2095 6.75 14.9234 6.75 14.625V9C6.75 8.70163 6.63147 8.41548 6.4205 8.20451C6.20952 7.99353 5.92337 7.875 5.625 7.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 9V14.625H9V9H14.625ZM14.625 7.875H9C8.70163 7.875 8.41548 7.99353 8.20451 8.20451C7.99353 8.41548 7.875 8.70163 7.875 9V14.625C7.875 14.9234 7.99353 15.2095 8.20451 15.4205C8.41548 15.6315 8.70163 15.75 9 15.75H14.625C14.9234 15.75 15.2095 15.6315 15.4205 15.4205C15.6315 15.2095 15.75 14.9234 15.75 14.625V9C15.75 8.70163 15.6315 8.41548 15.4205 8.20451C15.2095 7.99353 14.9234 7.875 14.625 7.875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_510_20747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.92257d90e6b9ba89832e324a0521b5ee.svg";
export { ForwardRef as ReactComponent };